import type { InvitedUsers } from './shared';
import { ReferralProgram202506Users } from './referral-program202506-users';
import { InvitedUsersGrid } from './invited-users-grid';
import { ReferralProgramExample } from './referral-program-example';
import { EmptyReferralSlots } from './empty-referral-slots';

export function ReferralProgress({
  invitedUsers,
  isReferralProgram,
  isReferralProgram202506,
  numInvited,
  tPrefix,
}: {
  invitedUsers: InvitedUsers;
  isReferralProgram: boolean;
  isReferralProgram202506: boolean;
  numInvited: number;
  tPrefix: string;
}) {
  if (isReferralProgram202506)
    return <ReferralProgram202506Users invitedUsers={invitedUsers} numInvited={numInvited} />;
  if (numInvited > 0) {
    return (
      <InvitedUsersGrid
        invitedUsers={invitedUsers}
        isReferralProgram={isReferralProgram}
        numInvited={numInvited}
        tPrefix={tPrefix}
      />
    );
  }
  if (isReferralProgram) return <ReferralProgramExample numInvited={numInvited} />;
  return <EmptyReferralSlots />;
}
